import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    paddingLeft:0,
    "&:hover, &:focus,&:focus-within,&:focus-visible,&:active": {
      //backgroundColor: theme.palette.background.linkActive,
      backgroundColor:theme.palette.background.linkActiveBg,
      borderLeft:"5px solid "+theme.palette.background.linkActive
    },
    color:"#fff",
    borderLeft:"5px solid "+theme.palette.background.sidebar
  },
  linkActive: {
    paddingLeft:0,
    //backgroundColor: theme.palette.background.linkActive,
    backgroundColor:theme.palette.background.linkActiveBg,
    borderLeft:"5px solid "+theme.palette.background.linkActive
  },
  linkNested: {
    padding: 0,
    "&:hover, &:focus": {
      //backgroundColor: theme.palette.background.linkActive,
      backgroundColor:"#333435",
      borderLeft:"5px solid "+theme.palette.background.linkActive
    },
  },
  linkiconadj: {
    minWidth: 43,
  },
  linkIcon: {
    // marginRight: theme.spacing(1),
    color: theme.appbar.text,
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: theme.palette.primary.main,
  },

  isCollapsed: {
   paddingRight:  0,
  },

  linkText: {
    padding: 0,
    marginLeft: 0,
    // color: theme.palette.text.secondary + "CC",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 14,
    whiteSpace: `nowrap`,
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    maxWidth: '145px !important',
  },
  
  nestedLinkText: {
    paddingRight: 10,
    marginLeft: 0,
    // color: theme.palette.text.secondary + "CC",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 14,
    whiteSpace: `nowrap`,
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    maxWidth: '145px',
  },
  linkTextActive: {
    //color: theme.palette.text.primary + "CC",
    color:theme.palette.background.linkActive
  },
  linkTextHidden: {
    //opacity: 0,
  },
  nestedList: {
    borderRadius: "0 !important",
    padding: "0px !important",
    //paddingLeft: theme.spacing(2) + 30,
    //position: "fixed",
    left: theme.spacing(2) + 210,
    //background: "#ccc",
    //zIndex:1000,
    MuiPopoverPaper: {
      borderRadius: 0,
    },
  },
  sectionTitle: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color:"#fff"
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    height: 1,
    backgroundColor: "#D8D8D880",
  },

}));


export const getMuiTheme = (selectedTheme) => {
  return createMuiTheme({
    ...selectedTheme,
    overrides: {
      MuiListItemIcon:{
        root:{
          minWidth:40
        }  
      },
      MuiMenuItem:{
        root:{
          paddingBottom:2,
          paddingTop:2,
        }
      },
      MuiMenu:{
        list:{
          backgroundColor:selectedTheme.palette.background.sidebar
        }
      },
      MuiSvgIcon:{
        root:{
          color:"#fff"
        }
      }
    },
  })
}

